var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAgreementAgree(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u30D7\\u30E9\\u30A4\\u30D0\\u30B7\\u30FC\\u8A2D\\u5B9A_top_\\u540C\\u610F",
    transform: "translate(-17.000000, -309.000000)",
    fill: "#0091DC"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(17.000000, 309.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    opacity: 0,
    x: 0,
    y: 0,
    width: 20,
    height: 20,
    rx: 10
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    stroke: "#0091DC",
    fillRule: "nonzero",
    points: "7.81818182 13.119403 4.95454545 10.2985075 4 11.238806 7.81818182 15 16 6.94029851 15.0454545 6"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAgreementAgree);
export default __webpack_public_path__ + "static/media/agreement_agree.84fc9b1267f2e575837f1ffa41edfcf3.svg";
export { ForwardRef as ReactComponent };